export const messages = {
  en: {
    servAppraiseManage: {
      queryTitle: 'Query Conditions',
      servNamePlaceholder: 'Service Name',
      userPlaceholder: 'User Name',
      servIdPlaceholder: 'Service ID',
      queryBtn: 'Search',
      resetBtn: 'Reset',
      tableTitle: 'Service Appraise',
      table: {
        servName: 'Service Name',
        appraiseUserName: 'User',
        appraiseScore: 'Score',
        context: 'Content',
        imgPath: 'Images',
        createTime: 'Create Time',
        operation: 'Operation',
        replyBtn: 'Reply'
      }
    }
  },
  zh: {
    servAppraiseManage: {
      queryTitle: '查询条件',
      servNamePlaceholder: '服务名称',
      userPlaceholder: '请输入用户',
      servIdPlaceholder: '请输入服务编号',
      queryBtn: '查询',
      resetBtn: '重置',
      tableTitle: '服务评论',
      table: {
        servName: '服务名称',
        appraiseUserName: '用户',
        appraiseScore: '评分',
        context: '内容',
        imgPath: '图片',
        createTime: '评论时间',
        operation: '操作',
        replyBtn: '回复'
      }
    }
  }
}